export default "__VITE_ASSET__BiTze3nT__"